import { Loader2 } from 'lucide-react';

export function DefaultPendingComponent() {
  return (
    <div className="flex h-full min-h-[60vh] items-center justify-center">
      <Loader2 className="size-6 animate-spin text-muted-foreground" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
